<script setup>
import { computed, useAttrs } from 'vue'

defineProps({
    modelValue: {
        type: [String, Number],
        default: '',
    },
})

const emit = defineEmits(['update:modelValue'])

// Class and style stay on the wrapper, where a parent's scoped rules expect
// them; everything else — listeners included — belongs on the select itself.
defineOptions({ inheritAttrs: false })

const attrs = useAttrs()

const selectAttrs = computed(() => {
    const { class: className, style, ...rest } = attrs
    return rest
})
</script>

<template>
    <div
        class="base-select"
        :class="$attrs.class"
        :style="$attrs.style"
    >
        <select
            :value="modelValue"
            class="select"
            v-bind="selectAttrs"
            @input="emit('update:modelValue', $event.target.value)"
        >
            <slot />
        </select>
        <div class="arrow">
            <BaseIcon
                class="arrow-icon"
                name="chevron-down"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.base-select {
    position: relative;
    overflow: hidden;
    background: $c-surface-raised;
    border-radius: $size-input-border-radius;
}

.select {
    @extend %input;

    position: relative;
    z-index: 1;
    max-width: unset;
    padding-right: 0;
    margin-bottom: 0;
    background: transparent;
}

.arrow {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
    display: flex;
    align-items: center;
    height: $size-input-height;
    padding: 0 $s-s;
}

.arrow-icon {
    @include square($s-l);

    color: $c-text-tertiary;
}
</style>
